import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import withAll from 'components/base/withAll';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import ReportRow from 'components/common/CompetitiveReports/CustomizedReportList/ReportRow';
import NoResultCard from 'components/base/NoResultCard';

const styles = () => ({
  root: {},
});

const CustomizedReportList = ({ classes, competitiveReports }) => {
  if (isEmpty(competitiveReports)) {
    return <NoResultCard noResultMessage="No reports created yet." />;
  }
  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Title</TableCell>
            <TableCell align="left">Download</TableCell>
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {competitiveReports.map(r => <ReportRow report={r} />)}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

CustomizedReportList.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  competitiveReports: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = ({ customizedCompetitiveReports }) => ({
  competitiveReports: get(customizedCompetitiveReports, 'data.results', []),
});

export default withAll(
  connect(mapStateToProps, null),
  withStyles(styles),
)(CustomizedReportList);
